<form [formGroup]="educationForm" class="max-w-5xl space-y-4" (ngSubmit)="saveEducation()">
  <details [open]="isSectionOpen('tenth')" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center justify-between text-sm font-semibold text-slate-700" [formGroup]="tenth" (click)="toggleSection('tenth', $event)">
      <div class="flex items-center gap-2">
        <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
        10th
      </div>
      <div class="flex items-center gap-2 text-slate-600">
        <span class="text-sm font-medium">Completed</span>
<input
  type="checkbox"
  class="toggle toggle-sm toggle-primary"
  formControlName="completed"
  (click)="$event.stopPropagation()"
  (change)="onStandardCompletedChange('tenth')">      </div>
    </summary>
    <div class="mt-3 bg-zinc-100 border rounded-md p-6 space-y-4" [formGroup]="tenth">
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Percentage</label>
        <div>
          <input type="number" min="0" max="100" class="input input-bordered w-full" [ngClass]="{ 'error': showError(tenth.get('percentage')) }" formControlName="percentage">
          @if (showError(tenth.get('percentage'))) {
            <span class="text-red-500 text-xs">{{ getPercentageError(tenth.get('percentage')) }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Year of Passing</label>
        <div>
          <input type="number" class="input input-bordered w-full" [ngClass]="{ 'error': showError(tenth.get('year_of_degree')) }" formControlName="year_of_degree">
          @if (showError(tenth.get('year_of_degree'))) {
            <span class="text-red-500 text-xs">{{ getYearError(tenth.get('year_of_degree'), 'Year of Passing') }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Institute</label>
        <div>
          <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(tenth.get('institute_name')) }" formControlName="institute_name">
          @if (showError(tenth.get('institute_name'))) {
            <span class="text-red-500 text-xs">{{ getTextError(tenth.get('institute_name'), 'Institute') }}</span>
          }
        </div>
      </div>
    </div>
  </details>

  <details [open]="isSectionOpen('twelfth')" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center justify-between text-sm font-semibold text-slate-700" [formGroup]="twelfth" (click)="toggleSection('twelfth', $event)">
      <div class="flex items-center gap-2">
        <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
        12th
      </div>
      <div class="flex items-center gap-2 text-slate-600">
        <span class="text-sm font-medium">Completed</span>
<input
  type="checkbox"
  class="toggle toggle-sm toggle-primary"
  formControlName="completed"
  (click)="$event.stopPropagation()"
  (change)="onStandardCompletedChange('twelfth')">      </div>
    </summary>
    <div class="mt-3 bg-zinc-100 border rounded-md p-6 space-y-4" [formGroup]="twelfth">
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Percentage</label>
        <div>
          <input type="number" min="0" max="100" class="input input-bordered w-full" [ngClass]="{ 'error': showError(twelfth.get('percentage')) }" formControlName="percentage">
          @if (showError(twelfth.get('percentage'))) {
            <span class="text-red-500 text-xs">{{ getPercentageError(twelfth.get('percentage')) }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Year of Passing</label>
        <div>
          <input type="number" class="input input-bordered w-full" [ngClass]="{ 'error': showError(twelfth.get('year_of_degree')) }" formControlName="year_of_degree">
          @if (showError(twelfth.get('year_of_degree'))) {
            <span class="text-red-500 text-xs">{{ getYearError(twelfth.get('year_of_degree'), 'Year of Passing') }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Institute</label>
        <div>
          <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(twelfth.get('institute_name')) }" formControlName="institute_name">
          @if (showError(twelfth.get('institute_name'))) {
            <span class="text-red-500 text-xs">{{ getTextError(twelfth.get('institute_name'), 'Institute') }}</span>
          }
        </div>
      </div>
    </div>
  </details>

  <details [open]="isSectionOpen('graduation')" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center justify-between text-sm font-semibold text-slate-700" [formGroup]="graduation" (click)="toggleSection('graduation', $event)">
      <div class="flex items-center gap-2">
        <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
        Graduation
      </div>
      <div class="flex items-center gap-2 text-slate-600">
        <span class="text-sm font-medium">Completed</span>
<input
  type="checkbox"
  class="toggle toggle-sm toggle-primary"
  formControlName="completed"
  (click)="$event.stopPropagation()"
  (change)="onStandardCompletedChange('graduation')">      </div>
    </summary>
    <div class="mt-3 bg-zinc-100 border rounded-md p-6 space-y-4" [formGroup]="graduation">
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Degree</label>
        <div>
          <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(graduation.get('degree')) }" formControlName="degree">
          @if (showError(graduation.get('degree'))) {
            <span class="text-red-500 text-xs">{{ getTextError(graduation.get('degree'), 'Degree') }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Percentage</label>
        <div>
          <input type="number" min="0" max="100" class="input input-bordered w-full" [ngClass]="{ 'error': showError(graduation.get('percentage')) }" formControlName="percentage">
          @if (showError(graduation.get('percentage'))) {
            <span class="text-red-500 text-xs">{{ getPercentageError(graduation.get('percentage')) }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Year of Graduation</label>
        <div>
          <input type="number" class="input input-bordered w-full" [ngClass]="{ 'error': showError(graduation.get('year_of_degree')) }" formControlName="year_of_degree">
          @if (showError(graduation.get('year_of_degree'))) {
            <span class="text-red-500 text-xs">{{ getYearError(graduation.get('year_of_degree'), 'Year of Graduation') }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Institute</label>
        <div>
          <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(graduation.get('institute_name')) }" formControlName="institute_name">
          @if (showError(graduation.get('institute_name'))) {
            <span class="text-red-500 text-xs">{{ getTextError(graduation.get('institute_name'), 'Institute') }}</span>
          }
        </div>
      </div>
    </div>
  </details>

  <details [open]="isSectionOpen('postGraduation')" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center justify-between text-sm font-semibold text-slate-700" [formGroup]="postGraduation" (click)="toggleSection('postGraduation', $event)">
      <div class="flex items-center gap-2">
        <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
        Post Graduation
      </div>
      <div class="flex items-center gap-2 text-slate-600">
        <span class="text-sm font-medium">Completed</span>
<input
  type="checkbox"
  class="toggle toggle-sm toggle-primary"
  formControlName="completed"
  (click)="$event.stopPropagation()"
  (change)="onStandardCompletedChange('postGraduation')">      </div>
    </summary>
    <div class="mt-3 bg-zinc-100 border rounded-md p-6 space-y-4" [formGroup]="postGraduation">
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Degree</label>
        <div>
          <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(postGraduation.get('degree')) }" formControlName="degree">
          @if (showError(postGraduation.get('degree'))) {
            <span class="text-red-500 text-xs">{{ getTextError(postGraduation.get('degree'), 'Degree') }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Percentage</label>
        <div>
          <input type="number" min="0" max="100" class="input input-bordered w-full" [ngClass]="{ 'error': showError(postGraduation.get('percentage')) }" formControlName="percentage">
          @if (showError(postGraduation.get('percentage'))) {
            <span class="text-red-500 text-xs">{{ getPercentageError(postGraduation.get('percentage')) }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Year of Graduation</label>
        <div>
          <input type="number" class="input input-bordered w-full" [ngClass]="{ 'error': showError(postGraduation.get('year_of_degree')) }" formControlName="year_of_degree">
          @if (showError(postGraduation.get('year_of_degree'))) {
            <span class="text-red-500 text-xs">{{ getYearError(postGraduation.get('year_of_degree'), 'Year of Graduation') }}</span>
          }
        </div>
      </div>
      <div class="grid grid-cols-[180px_1fr] items-center gap-4">
        <label class="text-sm font-medium text-slate-700">Institute</label>
        <div>
          <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(postGraduation.get('institute_name')) }" formControlName="institute_name">
          @if (showError(postGraduation.get('institute_name'))) {
            <span class="text-red-500 text-xs">{{ getTextError(postGraduation.get('institute_name'), 'Institute') }}</span>
          }
        </div>
      </div>
    </div>
  </details>

  <details [open]="isSectionOpen('professionalCourses')" class="group border-b pb-4">
    <summary class="cursor-pointer list-none flex items-center justify-between text-sm font-semibold text-slate-700" (click)="toggleSection('professionalCourses', $event)">
      <div class="flex items-center gap-2">
        <span class="inline-block w-4 text-center group-open:rotate-90 transition-transform">&#9656;</span>
        Professional Courses
      </div>
      <div class="flex items-center gap-2 text-slate-600">
        <span class="text-sm font-medium">Completed</span>
        <input
          type="checkbox"
          class="toggle toggle-sm toggle-primary"
          formControlName="professionalCoursesCompleted"
          (click)="$event.stopPropagation()"
          (change)="onProfessionalCoursesCompletedChange()">
      </div>
    </summary>
    <div class="mt-3 space-y-4" formArrayName="professionalCourses">
      @for (course of professionalCourses.controls; track course; let i = $index) {
        <div class="relative bg-zinc-100 border rounded-md p-6 space-y-4" [formGroupName]="i">
          @if (i > 0) {
            <button
              type="button"
              class="btn btn-circle btn-outline btn-sm absolute right-1 top-1"
              aria-label="Remove professional course"
              (click)="removeProfessionalCourse(i, $event)">x</button>
          }
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Title</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(course.get('title')) }" formControlName="title">
              @if (showError(course.get('title'))) {
                <span class="text-red-500 text-xs">{{ getTextError(course.get('title'), 'Title') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Year</label>
            <div>
              <input type="number" class="input input-bordered w-full" [ngClass]="{ 'error': showError(course.get('year')) }" formControlName="year">
              @if (showError(course.get('year'))) {
                <span class="text-red-500 text-xs">{{ getYearError(course.get('year'), 'Year') }}</span>
              }
            </div>
          </div>
          <div class="grid grid-cols-[180px_1fr] items-center gap-4">
            <label class="text-sm font-medium text-slate-700">Institute</label>
            <div>
              <input type="text" class="input input-bordered w-full" [ngClass]="{ 'error': showError(course.get('institute')) }" formControlName="institute">
              @if (showError(course.get('institute'))) {
                <span class="text-red-500 text-xs">{{ getTextError(course.get('institute'), 'Institute') }}</span>
              }
            </div>
          </div>
          <div class="flex justify-end">
     </div>
        </div>
      }
      
    </div>
    @if (professionalCoursesCompleted?.value) {
      <a  (click)="addProfessionalCourse()" class="cursor-pointer text-end block mt-2 text-xs font-semibold text-sky-700 hover:underline">Add More</a>
    }

   
  </details>
  <div class="flex justify-end">
    <button type="submit" class="btn btn-primary" [disabled]="isSaving">
      {{ isSaving ? 'Saving...' : 'Save Education' }}
    </button>
  </div>
</form>
